import api from '../api'
export const setAuthorizationToken = (token) => {
	api.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
